/*
Version 0.140

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2019.

!Changelog

2020
	17-02-2020
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_team_slideshow = {};

(function(){
	 
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************

	this.onready = function() {

		/*
		Init: Team swiper
		*/
		var swiperTeam = new Swiper('.js-team-show-slideshow',{
			navigation: {
			  nextEl: '.js-team-show-next',
			  prevEl: '.js-team-show-prev',
			},
			slidesPerView: 1,
			loop: true,
      		spaceBetween: 0,
      		autoplay: {
			   delay: 2000
			},
			breakpoints: {
			
			}
		});

	};
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
		
}).apply(specific_team_slideshow); 